import React from "react";
import ImBg from "assets/images/im-bg.jpg";
import SecondaryButton from "components/SecondaryButton";
import { useNavigate } from "react-router-dom";

export default function LandingHeader() {
  const navigate = useNavigate();
  return (
    <>
      <div
        className={`flex flex-col relative justify-center min-h-screen px-5 font-bold text-center bg-no-repeat bg-cover md:px-0 md:text-6xl header-wrapper bg-inherit`}
        style={{
          backgroundImage: `url('${ImBg}')`,
          backgroundSize: "cover",
          backgroundPosition: "inherit",
          backgroundRepeat: "no-repeat",
          overflow: "hidden",
        }}
      >
        <div className="absolute inset-0 bg-gray-900 opacity-40" />
        <div className="relative mt-10 text-center heading-wrapper">
          <h1 className="text-2xl text-white">
            Desa semakin cerdas dan maju semua jadi lebih mudah
          </h1>
          <h4 className="text-base font-normal text-white">
            Ajak desamu ikut menjadi Geulanggang-Panah dengan inovasi dan pemanfaatan
            teknologi
          </h4>
          {/* <h1 className="mt-4">{profile?.ProfilDesa[0]?.nama}</h1> */}
        </div>
        <div className="md:flex w-full relative  md:justify-center md:space-x-8 btnWrapper mt-[58px] space-y-4 md:space-y-0">
          <SecondaryButton label="Registrasi Desa" onClick={() => navigate("/register")} />
          <button
            className="w-full px-5 md:px-10   md:w-auto bg-primary leading-6 py-6 text-base font-semibold text-white rounded-[16px]"
            type="button"
            onClick={() => navigate("/daftardesa")}
          >
            Lihat Desa Teregistrasi
          </button>
        </div>
      </div>
    </>
  );
}
